webpackJsonp([184655746423024],{

/***/ 736:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DestinationCards":"src-components-ProgramOverview-DestinationCards----DestinationCards-module---DestinationCards---2tUeI","Destination":"src-components-ProgramOverview-DestinationCards----DestinationCards-module---Destination---2yBDM","Destination__Image":"src-components-ProgramOverview-DestinationCards----DestinationCards-module---Destination__Image---St9yX","Destination__Details":"src-components-ProgramOverview-DestinationCards----DestinationCards-module---Destination__Details---3yPFt","anchor":"src-components-ProgramOverview-DestinationCards----DestinationCards-module---anchor---z6Ijf"};

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DestinationCardsModule = __webpack_require__(736);
	
	var _DestinationCardsModule2 = _interopRequireDefault(_DestinationCardsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DestinationCards = function DestinationCards(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _DestinationCardsModule2.default.DestinationCards },
	    props.cards.map(function (card, i) {
	      return _react2.default.createElement(
	        'div',
	        { className: _DestinationCardsModule2.default.Destination, key: i },
	        _react2.default.createElement('a', { className: _DestinationCardsModule2.default.anchor, id: card.destinationName }),
	        _react2.default.createElement(
	          'div',
	          { className: _DestinationCardsModule2.default.Destination__Image, style: { backgroundImage: 'url("' + card.featuredImage.file.url + '")' } },
	          _react2.default.createElement(
	            'h2',
	            null,
	            card.destinationName
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'hoverlink', to: card.link.link },
	            card.link.text
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _DestinationCardsModule2.default.Destination__Details },
	          card.destinationDetails.map(function (detail, iterator) {
	            return _react2.default.createElement(
	              'div',
	              { key: iterator, className: 'destination-card' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'h3' },
	                detail.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                detail.text.text
	              )
	            );
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = DestinationCards;
	module.exports = exports['default'];

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Nav":"src-components-ProgramOverview-Nav----Nav-module---Nav---39qs7","active":"src-components-ProgramOverview-Nav----Nav-module---active---37KUX"};

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavModule = __webpack_require__(738);
	
	var _NavModule2 = _interopRequireDefault(_NavModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = function Nav(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: '' + _NavModule2.default.Nav },
	    _react2.default.createElement(
	      'a',
	      { className: props.activeNav === 'ecuador' && _NavModule2.default.active, href: '#Ecuador' },
	      'Ecuador'
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: props.activeNav === 'brazil' && _NavModule2.default.active, href: '#Brazil' },
	      'Brazil'
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: props.activeNav === 'india' && _NavModule2.default.active, href: '#India' },
	      'India'
	    )
	  );
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Quiz":"src-components-ProgramOverview-Quiz----Quiz-module---Quiz---3EtxM"};

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QuizModule = __webpack_require__(739);
	
	var _QuizModule2 = _interopRequireDefault(_QuizModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quiz = function Quiz(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _QuizModule2.default.Quiz },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2' },
	      props.title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.text
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'button button--white', href: props.link.link },
	      props.link.text
	    )
	  );
	};
	
	exports.default = Quiz;
	module.exports = exports['default'];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _DestinationCards = __webpack_require__(543);
	
	var _DestinationCards2 = _interopRequireDefault(_DestinationCards);
	
	var _Nav = __webpack_require__(544);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Quiz = __webpack_require__(545);
	
	var _Quiz2 = _interopRequireDefault(_Quiz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DestinationLanding = function (_React$Component) {
	  _inherits(DestinationLanding, _React$Component);
	
	  function DestinationLanding(props) {
	    _classCallCheck(this, DestinationLanding);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeNav: 'ecuador'
	    };
	    return _this;
	  }
	
	  DestinationLanding.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var brazilLink = document.querySelector('#Brazil'),
	
	    //senegalLink = document.querySelector('#Senegal'),
	    indiaLink = document.querySelector('#India'),
	        offset = 420;
	
	    window.addEventListener('scroll', function () {
	      var brazilTrigger = brazilLink.offsetTop - offset,
	
	      //senegalTrigger = (senegalLink.offsetTop - offset),
	      indiaTrigger = indiaLink.offsetTop - offset;
	
	      var doc = document.documentElement,
	          top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	
	      if (top > indiaTrigger) {
	        _this2.state.activeNav != 'india' ? _this2.setState({ activeNav: 'india' }) : null;
	      } else if (top > brazilTrigger) {
	        _this2.state.activeNav != 'brazil' ? _this2.setState({ activeNav: 'brazil' }) : null;
	      } else {
	        _this2.state.activeNav != 'ecuador' ? _this2.setState({ activeNav: 'ecuador' }) : null;
	      }
	    });
	
	    var ScrollReveal = __webpack_require__(149);
	
	    window.setTimeout(function () {
	      window.sr = ScrollReveal();
	      sr.reveal('.destination-card', { duration: 600 });
	    }, 200);
	  };
	
	  DestinationLanding.prototype.render = function render() {
	    var page = this.props.data.page;
	
	    var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'dest' },
	      _react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
	      _react2.default.createElement(_Hero2.default, { title: page.title }),
	      _react2.default.createElement(_Nav2.default, { cards: page.destinationCards, activeNav: this.state.activeNav }),
	      _react2.default.createElement(_DestinationCards2.default, { cards: page.destinationCards }),
	      _react2.default.createElement(_Quiz2.default, {
	        title: page.quizTitle,
	        text: page.quizText,
	        link: page.quizLink
	      })
	    );
	  };
	
	  return DestinationLanding;
	}(_react2.default.Component);
	
	exports.default = DestinationLanding;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-destinations-overview-js-ed2190f18d592252e418.js